import * as ko from 'knockout';

import { app } from '../app';
import i18n from '../i18n';
import { Deferred } from '../utils/deferred';

const template = require('raw-loader!../../templates/components/overview_delete_dialog.html').default;

export interface OverviewDeleteFilterSummary {
  label: string;
  value: string;
}

interface OverviewDeleteDialogParams {
  valueCount: number;
  cellCount: number;
  filters: OverviewDeleteFilterSummary[];
}

class OverviewDeleteDialog {
  title: string;
  count: number;
  filters: OverviewDeleteFilterSummary[];
  private result: Deferred<{}>;

  constructor(params: OverviewDeleteDialogParams & { result: Deferred<{}> }) {
    this.title = i18n.t('Delete filtered data?')();
    // The number of grid cells the user sees; falls back to the stored-value count.
    this.count = params.cellCount || params.valueCount;
    this.filters = params.filters;
    this.result = params.result;
  }

  onConfirm = () => {
    this.result.resolve(null);
  };

  onCancel = () => {
    this.result.reject();
  };
}

ko.components.register('overview-delete-dialog', {
  viewModel: OverviewDeleteDialog,
  template: template,
});

// Opens the dialog and resolves when the user confirms, rejects when they cancel.
export function overviewDeleteDialog(params: OverviewDeleteDialogParams): Promise<{}> {
  return app.formsStackController.push({
    title: i18n.t('Delete filtered data?')(),
    name: 'overview-delete-dialog',
    params: {
      ...params,
      result: new Deferred<{}>(),
    },
  });
}
